module.exports = __webpack_public_path__ + "static/2-47d7373010af1f1c431a5c413d9900f9.jpg";